<template>
    <BottomSheet ref="sheet" max-height="68vh">

        <template #header>
            <h4 class="serif">Evit anumite alergene</h4>
            <p class="sh-note">Ascundem preparatele care conțin alergenii selectați.</p>
            <div class="f-row f-all">
                <label for="al-toate">Bifează tot</label>
                <input type="checkbox" id="al-toate" v-model="toateSelectate">
            </div>
        </template>

        <div class="f-row" v-for="a in Alergeni" :key="'alergen' + a.Id">
            <label :for="'al-' + a.Id">{{ a.Nume }}</label>
            <input type="checkbox" :id="'al-' + a.Id" true-value="1" false-value="0" v-model="a.Selectat">
        </div>

        <template #footer>
            <button class="sh-apply" @click="save">Aplică filtrul</button>
        </template>

    </BottomSheet>
</template>

<script>
import BasePage from '@/pages/BasePage';
import BottomSheet from '@/components/BottomSheet.vue';

export default {
    name: "FiltreDialog",
    extends: BasePage,
    components: { BottomSheet },

    data () {
        return {
            Alergeni:[]
        }
    },
    computed: {
        toateSelectate: {
            get() {
                return this.Alergeni.length > 0 && this.Alergeni.every( x => x.Selectat == '1' );
            },
            set(value) {
                this.Alergeni.forEach( a => { a.Selectat = value ? '1' : '0'; } );
            }
        }
    },
    methods: {
        show_me: async function( alergeni_selectati = [] ) {
            //sincronizam starea cu filtrul aplicat in pagina
            var iduri = alergeni_selectati.map( x => x.Id );
            this.Alergeni.forEach( a => {
                a.Selectat = iduri.indexOf(a.Id) >= 0 ? '1' : '0';
            });
            this.$refs.sheet.open();
        },

        async get_info(){
            var response   = await this.post("meniu/get_alergeni");
            this.Alergeni  = response.Alergeni.map( a => ({ ...a, Selectat: a.Selectat || '0' }) );
        },

        save: async function() {
            this.$refs.sheet.close();
            var selectati = this.Alergeni.filter( x => x.Selectat == '1');
            this.$emit("save", selectati);
        }
    },
    mounted: function() {
        this.get_info();
    }
};
</script>

<style lang="less" scoped>
h4 {
    font-size: 19px;
    margin: 6px 0 4px;
    font-weight: 600;
}

.sh-note {
    font-size: 12.5px;
    color: var(--m-muted);
    margin: 0 0 10px;
}

.f-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 11px 0;
    border-top: 1px solid var(--m-line);
    font-size: 14.5px;

    &:first-of-type {
        border-top: none;
    }

    label {
        flex: 1;
        cursor: pointer;
    }

    input {
        width: 20px;
        height: 20px;
        accent-color: var(--m-accent);
        cursor: pointer;
        flex: 0 0 auto;
    }
}

.f-all {
    border-top: none;
    border-bottom: 1px solid var(--m-line);
    font-weight: 700;
}

.sh-apply {
    width: 100%;
    background: var(--m-accent);
    color: var(--m-accent-ink);
    border: none;
    border-radius: 14px;
    font-size: 15px;
    font-weight: 700;
    padding: 13px;
    cursor: pointer;
}
</style>
